import Mock from 'mockjs'

// 商品列表
const MOCK050022 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'requirements|10-20': [{
            'orderNo': '@id',
            'requireNo':'@id',
            'requireBatchNo':'@id',
            'purchaserName': '@cname(5)',
            'supplierName': '@cname(5)',
            'requireName': '@cname(5)',
            'tradeTime': '@datetime',
            'requireCount|100-300': 100,
            'requireStatus': '05',
            'bRequireStatusDisp': '待供应商发货',
            'sRequireStatusDisp': '采购商已发起要货单',
        }],
        'requireBatchNos':[
            '1','2','3'
        ],
        'pageSize|10-20': 10,
        'totalCount|100-500': 100
    }
});

export default MOCK050022


// WEBPACK FOOTER //
// ./src/mock/getRequireOrderList.js